import { render } from "./inbetweenHeadline.vue?vue&type=template&id=62ac79f7"
import script from "./inbetweenHeadline.vue?vue&type=script&lang=js"
export * from "./inbetweenHeadline.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__